export default __webpack_public_path__ + "static/twitter_icon-1.0.0.svg";